export default function(roleToRemove, roleToAdd) {
  return {
    oldRole: roleToRemove,
    newRole: roleToAdd
  }
}

